if (typeof joining_settings !== 'undefined') {
	console.log('JoiningVars: ', joining_settings);
}

if (typeof joining_validation_fields_txt !== 'undefined') {
	console.log('Joining Fields Forms Settings', joining_validation_fields_txt);
}

const waterGlobalId = ['WATER-YANGA', 'WEB-WATER-YANGA', 'WEB-WATER-HUT2O', 'WEB-ADDON-WATER-YANGA', 'WEB-ADDON-WATER-HUT2O'];
const dayPassGlobalId = ['DAYPASS', 'DAYPASS_7', 'MF_AVULSO'];
const lockerGlobalId = ['WEB-LOCKER', 'WEB- LOCKER', 'WEB-ADDON-LOCKER'];
const subOneFlexPrimeId = ['MF_ONE_SP', 'MF_FLEX_SP', 'MF_PRIME_SP', 'MF_ONE_PT', 'MF_FLEX_PT', 'MF_PRIME_PT'];
const subOneId = [ 'ONE', 'MF_ONE', 'MF_ONE_SP', 'MF_ONE_PT'];
const subFlexId = ['FLEX', 'MF_FLEX', 'MF_FLEX_SP', 'MF_FLEX_PT'];
const subPrimeId = ['PRIME', 'MF_PRIME', 'MF_PRIME_SP', 'MF_PRIME_PT'];

class JoiningVars {
	static get_setting_field = (key, path='es-es', settings_type='global-settings', format = 'settings', modal_key = '') => {
		const all_settings = window.joining_settings ?? {};

		if (!all_settings[`/${path}/`] || !all_settings[`/${path}/`][settings_type]) {
			return undefined;
		}

		const settings = all_settings[`/${path}/`][settings_type];

		if (format === 'settings') {
			return settings.settings[key];
		}

		if (format === 'modal') {
			// allways modal_key is lowercase
			modal_key = modal_key.toLowerCase();

			const modal = settings.modals.find(modal => modal.modal_key === modal_key);
			return modal ? modal[key] : undefined;
		}

		return undefined;
	};

	static get_modal_setting_field = (modal_key, modal_field, path='es-es') => {
		return this.get_setting_field(modal_field, path, 'global-settings', 'modal', modal_key);
	};

	static get_form_field = (key) => {
		if (typeof joining_validation_fields_txt !== 'undefined') {
			return window.joining_validation_fields_txt[key];
		}
		return key;
	}
}
